import { render } from "./PurchaseReturn.vue?vue&type=template&id=071a4cd0&scoped=true"
import script from "./PurchaseReturn.vue?vue&type=script&lang=js"
export * from "./PurchaseReturn.vue?vue&type=script&lang=js"

import "./PurchaseReturn.vue?vue&type=style&index=0&id=071a4cd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071a4cd0"]])

export default __exports__